import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { BASEURL } from "../../constants";
import ShareCourseModal from './ShareCourseModal'
import DeleteCourseModal from './DeleteCourseModal'
import CourseCard from "../Global/CourseCard/CourseCard";
import {useNavigate } from 'react-router-dom'
import CourseCardList from "../Global/CourseCard/CourseCardList";

const PublishedCourses = ({ searchTerm, courseArray, viewToggle }) => {
    const [showDeleteModal, setShowDeleteModal] = useState({ show: false, courseId: null, imported: false })

    const [userCourses, setUserCourses] = useState([]);
    const [importedCourses, setImportedCourses] = useState([]);

    // const [showCreateCourseModal, setShowCreateCourseModal] = useState(false);
    const [filteredData, setFilteredData] = useState([]); // Filtered school data for display

    const [dropdownState, setDropdownState] = useState({}); // State to track each dropdown's open state

    const [showShareCousrseModal, setShowShareCousrseModal] = useState(false);

    const [coverImages, setCoverImages] = useState({});
    const navigate = useNavigate();
    // function checkImageExists(imageUrl) {
    //     return new Promise((resolve, reject) => {
    //         const image = new Image();
    //         image.onload = () => resolve();
    //         image.onerror = () => reject();
    //         image.src = imageUrl;
    //     });
    // }



    // const toggleDropdown = (courseId) => {
    //     setDropdownState(prevState => ({
    //         ...prevState,
    //         [courseId]: !prevState[courseId]
    //     }));
    // };

    const handleShareClick = (courseId) => {
        const course = userCourses.find(course => course.id === courseId);
        console.log('Sharing course:', course);
        setShowShareCousrseModal({ state: true, courseId });
    };


    // useEffect(() => {
    //     const fetchCourses = async () => {
    //         try {
    //             const userId = localStorage.getItem('auth');
    //             if (userId) {
    //                 const response = await axios.post(`${BASEURL}/api/fetch-published-courses`);

    //                 const courseData = response.data.courseData;
    //                 console.log('courseData', courseData)
    //                 const publishedCourses = courseData.filter(course =>
    //                     course.verify_status === 'verified' &&
    //                     course.course_status === 'completed' &&
    //                     course.publish_status === 'published'
    //                 );

    //                 // setUserCourses(courseData.length ? courseData : []);

    //                 if (publishedCourses.length === 0) {
    //                     setUserCourses([]);
    //                 } else {
    //                     setUserCourses(publishedCourses);
    //                     // console.log("",response.data)
    //                 }
    //                 console.log('API Data:', publishedCourses);
    //             }
    //         } catch (error) {
    //             console.error("Error fetching user courses:", error);
    //         }
    //     };

    //     fetchCourses();
    // }, []);




    useEffect(() => {
        const filtered = [...courseArray].filter(course =>
            course.course_name && course.course_name.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredData(filtered);
    }, [searchTerm, courseArray ]);



    function deleteCourse(courseId) {
        if (showDeleteModal.imported) {
            axios.delete(`${BASEURL}/api/delete-imported-course`, {
                params: { courseId: courseId },
            }).then((response) => {
                if (response.data.status === "success") {
                    setUserCourses(userCourses => userCourses.filter(course => course.id !== courseId));
                    setShowDeleteModal({ show: false, courseId: null, imported: false })
                }
            })
        } else {
            axios.delete(`${BASEURL}/api/delete-course`, {
                params: { courseId: courseId },
            }).then((response) => {
                if (response.data.status === "success") {
                    setUserCourses(userCourses => userCourses.filter(course => course.id !== courseId));
                    setShowDeleteModal({ show: false, courseId: null, imported: false })
                }
            });
        }
    }

    function handleDelete(courseId) {
        setShowDeleteModal({ state: true, courseId: courseId });
    }

    function handleCloseDeleteModal() {
        setShowDeleteModal({ state: false, courseId: null });
    }

    const fetchCourseData = async (courseId) => {
        try {
            const response = await axios.get(`${BASEURL}/api/courses/${courseId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching course data:', error);
            return null;
        }
    };

    function formatArrayToString(array) {
        return array.join(', ');
    }


    const truncateText = (text, maxLength) => {
        if (text.length <= maxLength) {
            return text;
        }
        return text.substring(0, maxLength) + '...';
    };


    const truncateGrade = (grade, maxLength) => {
        if (grade.length <= maxLength) {
            return `Grade: ${grade}`;
        } else {
            const truncatedGrade = grade.substring(0, maxLength);
            return `Grade: ${truncatedGrade} + more`;
        }
    };


    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };


    function formatClassId(classId) {
        // Check if classId is a string, if not, convert it to a string
        const classIdString = typeof classId === 'string' ? classId : String(classId);

        // Use regex to match all sequences of digits, sort them, and join them with commas and spaces
        const sortedClassIds = classIdString.match(/\d+/g)?.map(Number).sort((a, b) => a - b).join(', ') || '';

        return sortedClassIds;
    }

    function formatTags(tag) {
        if (!tag || !Array.isArray(tag) || tag.length === 0) {
            return 'No tags available'; // Handle case where tag is not an array, is empty, or has no elements
        }

        // Join the array elements into a comma-separated string
        return tag.join(', ');
    }

    function courseCardClickHandler(){

    }


    return (
        <>
            {/* <ShareCourseModal
                isOpen={showShareCousrseModal.state}
                onClose={() => setShowShareCousrseModal({ state: false, courseId: null })}
                courseDetails={{
                    id: showShareCousrseModal.courseId,
                    courseName: userCourses.find(course => course.id === showShareCousrseModal.courseId)?.course_name,
                    subjectName: userCourses.find(course => course.id === showShareCousrseModal.courseId)?.subject_name,
                    courseDescription: userCourses.find(course => course.id === showShareCousrseModal.courseId)?.course_desc,
                }}
            /> */}

            <ShareCourseModal
                isOpen={showShareCousrseModal.state}
                onClose={() => setShowShareCousrseModal({ state: false, courseId: null })}
                courseDetails={{
                    id: showShareCousrseModal.courseId,
                    courseName: filteredData.find(course => course.id === showShareCousrseModal.courseId)?.course_name,
                    subjectName: filteredData.find(course => course.id === showShareCousrseModal.courseId)?.subject_name,
                    courseDescription: filteredData.find(course => course.id === showShareCousrseModal.courseId)?.course_desc,
                    masterCourseId: filteredData.find(course => course.id === showShareCousrseModal.courseId)?.master_course_id
                }}
            />

            <DeleteCourseModal showDeleteModal={showDeleteModal} setShowDeleteModal={setShowDeleteModal} deleteCourse={deleteCourse} />

            <div className={viewToggle=="tile" ? "rounded-md" : "flex flex-wrap gap-6"}>
                {filteredData.length === 0 ? (
                    <div className="col-span-full w-full my-0 mx-auto">
                        <div className="flex justify-center my-0 mx-auto w-full">
                            <div className="flex flex-col items-center text-center max-w-sm">
                                <p className="p-3 text-sm font-medium text-blue-500 rounded-full bg-blue-50">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="w-6 h-6 flex justify-center">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
                                    </svg>
                                </p>
                                <p className="text-xl font-bold mt-2 text-gray-700">Oops! No courses found.</p>
                                <p className="mt-2">It looks like there are no courses here. Why not create one and get started?</p>
                            </div>
                        </div>
                    </div>
                ) : (
                    filteredData.map((course, index) => {
                        return (<>
                            {viewToggle=="tile" ? <CourseCardList type='published' course={course} courseId={course.master_course_id} onClickHandler={courseCardClickHandler} setShowDeleteModal={setShowDeleteModal} /> : <CourseCard type='published' course={course} courseId={course.master_course_id} onClickHandler={courseCardClickHandler} setShowDeleteModal={setShowDeleteModal} />}

                        </>)
                    }
                    )

                )}
            </div>
        </>
    )
}

export default PublishedCourses